export default function getFieldId(inputId, registration, name) {
  return inputId ?? registration?.name ?? name;
}
